import {NgModule} from '@angular/core';
import {BdConfigPage} from "./page/bd-config/bd-config.page";
import {BdDunningDashboardPage} from "./page/bd-dunning-dashboard/bd-dunning-dashboard.page";
import {BD_ENTITY_PROVIDER} from "./bd.entity-provider";
import {CoreModule} from "../../core/core.module";
import {NsModule} from "../../feature-core/ns/ns.module";
import {JbModule} from "../../feature-tech/jb/jb.module";
import {
    BmCustomerAccountTransactionComponent
} from "../bm/component/object-components/bm-customer-account-object-component/shared/bm-customer-account-transaction-component/bm-customer-account-transaction.component";
import {BD_TEST_PROVIDERS} from "./test/bd-test-definition";
import {
    BD_UI_COMPONENT_REGISTRY_INITIALIZER
} from "./service/bd-ui-component-registry-initializer";

// Shared components
import {
    DunningBalanceDisplayComponent
} from "./component/shared/dunning-balance-display/dunning-balance-display.component";
import {
    DunningManualTransactionsSectionComponent
} from "./component/shared/dunning-manual-transactions-section/dunning-manual-transactions-section.component";
import {BdOpenActionsTabComponent} from "./component/shared/bd-open-actions-tab/bd-open-actions-tab.component";
import {
    BdOpenActionDrawerComponent
} from "./component/shared/bd-open-action-drawer/bd-open-action-drawer.component";
import {
    BdMahnwesenKpiComponent
} from "./component/shared/bd-mahnwesen-kpi/bd-mahnwesen-kpi.component";
import {BdEnumLabelPipe} from "./component/shared/pipes/bd-enum-label.pipe";
import {BdReceivableAmountPipe} from "./component/shared/pipes/bd-receivable-amount.pipe";

// Transparenz-Audit — Steuerungs-Cockpit (GAP-T01/T07/T11/T12)
import {
    BdKpiTrendComponent
} from "./component/shared/bd-kpi-trend/bd-kpi-trend.component";
import {
    BdPortfolioAuditTabComponent
} from "./component/shared/bd-portfolio-audit-tab/bd-portfolio-audit-tab.component";
import {
    BdRunHistoryTabComponent
} from "./component/shared/bd-run-history-tab/bd-run-history-tab.component";

// Welle C — Entscheidungs-Kontext (C01/C02/C11/C13/C14)
import {
    BdDecisionContextComponent
} from "./component/shared/bd-decision-context/bd-decision-context.component";
import {
    BdSaldoBreakdownComponent
} from "./component/shared/bd-saldo-breakdown/bd-saldo-breakdown.component";
// Abgeschlossen-Ansicht der Inkassoübergabe (Kopf, Kennzahlen, drei transiente Widget-Tabellen)
import {
    BdHandOverCompletionSummaryComponent
} from "./component/shared/bd-hand-over-completion-summary/bd-hand-over-completion-summary.component";
// TM-1000001976 — geteilter, einklappbarer Kundeninformations-Block (self-loading via dunningId)
import {
    BdCustomerInfoComponent
} from "./component/shared/bd-customer-info/bd-customer-info.component";
// TM-1000001976 — geteilter Bereichs-Ticket-SplitButton ("Ticket erstellen", self-loading via dunningId + functionArea)
import {
    BdAreaTicketButtonComponent
} from "./component/shared/bd-area-ticket-button/bd-area-ticket-button.component";
// TM-1000001976 — geteilter KI-Bereichsanalyse-Block (self-loading via dunningId + functionArea, bold-only safe render)
import {
    BdAreaAnalysisComponent
} from "./component/shared/bd-area-analysis/bd-area-analysis.component";
// TM-1000001976 — geteilte, konfigurierbare BD-Prozess-Komponenten (Saldo-Block + Vertrags-Entscheidung)
import {
    BdSaldoBlockComponent
} from "./component/shared/bd-saldo-block/bd-saldo-block.component";
import {
    BdContractDecisionSectionComponent
} from "./component/shared/bd-contract-decision-section/bd-contract-decision-section.component";
// TM-1000001976 (B.2) — geteilter, konfigurierbarer „Offene Gebühren"-Baustein
import {
    BdOpenFeesSectionComponent
} from "./component/shared/bd-open-fees-section/bd-open-fees-section.component";
// TM-1000001976 (B.3) — geteilte, konfigurierbare „Finale Forderungssicht"
import {
    BdFinalForderungssichtComponent
} from "./component/shared/bd-final-forderungssicht/bd-final-forderungssicht.component";
import {
    BdContractSimulationComponent
} from "./component/shared/bd-contract-simulation/bd-contract-simulation.component";
import {
    BdDunningHistoryComponent
} from "./component/shared/bd-dunning-history/bd-dunning-history.component";

// Wave 2.1-2.4 — Pending-Action Resolver + Dialoge
import {
    BdPendingActionResolverComponent
} from "./component/shared/bd-pending-action-resolver/bd-pending-action-resolver.component";
import {
    BdHandOverApprovalDialogComponent
} from "./component/shared/bd-hand-over-approval-dialog/bd-hand-over-approval-dialog.component";
import {
    BdPlanBreakDecisionDialogComponent
} from "./component/shared/bd-plan-break-decision-dialog/bd-plan-break-decision-dialog.component";
import {
    BdPauseDialogComponent as BdPauseDialogSharedComponent
} from "./component/shared/bd-pause-dialog/bd-pause-dialog.component";

// DunningProposal Review-Gate (Mahnvorschläge) — review tab, dashboard workbench,
// shared approval dialog and the ad-hoc jobs control.
import {
    BdDunningProposalApprovalDialogComponent
} from "./component/shared/bd-dunning-proposal-approval-dialog/bd-dunning-proposal-approval-dialog.component";
import {
    BdDunningProposalWorkbenchComponent
} from "./component/shared/bd-dunning-proposal-workbench/bd-dunning-proposal-workbench.component";
import {
    BdDunningReviewWorkbenchComponent
} from "./component/shared/bd-dunning-review-workbench/bd-dunning-review-workbench.component";
// Incoming money on a running dunning (projects/bm_money_received): workbench + block „Geldeingang prüfen“,
// embedded by the bm host bm-payment-reconciliation-dunning (BmModule imports BdModule).
import {
    BdDunningPaymentReviewWorkbenchComponent
} from "./component/shared/bd-dunning-payment-review-workbench/bd-dunning-payment-review-workbench.component";
import {
    BdDunningPaymentReviewDetailComponent
} from "./component/shared/bd-dunning-payment-review-detail/bd-dunning-payment-review-detail.component";
import {
    BdDunningActionReleaseWorkbenchComponent
} from "./component/shared/bd-dunning-action-release-workbench/bd-dunning-action-release-workbench.component";
import {
    BdHandoverApprovalListComponent
} from "./component/shared/bd-handover-approval-list/bd-handover-approval-list.component";
import {
    BdDunningSimulationTabComponent
} from "./component/shared/bd-dunning-simulation-tab/bd-dunning-simulation-tab.component";
import {
    BdDunningJobsTabComponent
} from "./component/shared/bd-dunning-jobs-tab/bd-dunning-jobs-tab.component";
// Arbeitsliste der Mahnungen, die die Stoppprüfung absichtlich offen hält (navItem=stopWaiting).
import {
    BdDunningStopWaitingTabComponent
} from "./component/shared/bd-dunning-stop-waiting-tab/bd-dunning-stop-waiting-tab.component";
// Mahnsperren-Werkbank (navItem=dunningBlocks): Sperren des Mahnstarts je Abrechnungskonto.
import {
    BdDunningBlockWorkbenchComponent
} from "./component/shared/bd-dunning-block-workbench/bd-dunning-block-workbench.component";
// Lean scheduling dialog for one provisioned bd module job (cadence / time / activation),
// writing through the generic jb.JbJobType CRUD service. Opened from the jobs tab.
import {
    BdJobScheduleDialogComponent
} from "./component/shared/bd-job-schedule-dialog/bd-job-schedule-dialog.component";

// TM-1000001961 — der frühere Summen-Zuweisungs-Dialog (bd-fee-assignment-dialog)
// wurde entfernt: die Einigungsgebühr-/Kulanz-Erfassung lebt jetzt inline in
// Schritt 4 des Zahlungsplan-Object-Components.

// Object components
import {DunningObjectComponent} from "./component/object/dunning-object/dunning-object.component";
import {
    DunningHandOverObjectComponent
} from "./component/object/dunning-hand-over-object/dunning-hand-over-object.component";
import {
    DunningPaymentPlanObjectComponent
} from "./component/object/dunning-payment-plan-object/dunning-payment-plan-object.component";
import {
    DunningPaymentDistributionObjectComponent
} from "./component/object/dunning-payment-distribution-object/dunning-payment-distribution-object.component";
import {DunningTypeObjectComponent} from "./component/object/dunning-type-object/dunning-type-object.component";
import {
    DunningProposalObjectComponent
} from "./component/object/dunning-proposal-object/dunning-proposal-object.component";

// DunningType-OBC — Schicht 2/3 des Drei-Schichten-Musters (Basis + Voll- und Seitenansicht)
import {
    BdDunningTypeBaseComponent
} from "./component/object/dunning-type-object/view/base/bd-dunning-type-base.component";
import {
    BdDunningTypeFullComponent
} from "./component/object/dunning-type-object/view/full/bd-dunning-type-full.component";
import {
    BdDunningTypeSideComponent
} from "./component/object/dunning-type-object/view/side/bd-dunning-type-side.component";

// DunningType-OBC — geteilte Kindtabelle für alle zehn Kind-Navigationspunkte
import {
    BdDunningTypeChildTableComponent
} from "./component/object/dunning-type-object/shared/bd-dunning-type-child-table/bd-dunning-type-child-table.component";

// bd-dunningtype-overview — rein lesende Konfigurationsübersicht der DunningType-OBC
import {
    BdDunningTypeOverviewComponent
} from "./component/object/dunning-type-object/view/overview/bd-dunning-type-overview.component";

// Wave 3 — dynamic exit-UI components
import {
    BdContractDecisionTableComponent
} from "./component/uicomponent/bd-contract-decision-table/bd-contract-decision-table.component";
import {
    BdLvDecisionTableComponent
} from "./component/uicomponent/bd-lv-decision-table/bd-lv-decision-table.component";
import {
    BdHandoverApprovalComponent
} from "./component/uicomponent/bd-handover-approval/bd-handover-approval.component";
import {
    BdPauseDialogComponent
} from "./component/uicomponent/bd-pause-dialog/bd-pause-dialog.component";
import {
    BdPlanBreakDecisionComponent
} from "./component/uicomponent/bd-plan-break-decision/bd-plan-break-decision.component";
import {
    BdHandoverConfigurationComponent
} from "./component/uicomponent/bd-handover-configuration/bd-handover-configuration.component";

// Wave 4 — additional dynamic exit-UI components
import {
    BdWriteOffDialogComponent
} from "./component/uicomponent/bd-write-off-dialog/bd-write-off-dialog.component";
import {
    BdRateAgreementDialogComponent
} from "./component/uicomponent/bd-rate-agreement-dialog/bd-rate-agreement-dialog.component";
import {
    BdEscalationDialogComponent
} from "./component/uicomponent/bd-escalation-dialog/bd-escalation-dialog.component";
import {
    BdGenericFormDialogComponent
} from "./component/uicomponent/bd-generic-form-dialog/bd-generic-form-dialog.component";

@NgModule({
    declarations: [
        BdConfigPage,
        BdDunningDashboardPage,
        // Shared components
        DunningBalanceDisplayComponent,
        DunningManualTransactionsSectionComponent,
        BdOpenActionsTabComponent,
        BdOpenActionDrawerComponent,
        BdMahnwesenKpiComponent,
        // Shared pipes
        BdEnumLabelPipe,
        BdReceivableAmountPipe,
        // Transparenz-Audit — Steuerungs-Cockpit (GAP-T01/T07/T11/T12)
        BdKpiTrendComponent,
        BdPortfolioAuditTabComponent,
        BdRunHistoryTabComponent,
        // Welle C — Entscheidungs-Kontext (C01/C02/C11/C13/C14)
        BdDecisionContextComponent,
        BdSaldoBreakdownComponent,
        BdHandOverCompletionSummaryComponent,
        BdContractSimulationComponent,
        BdDunningHistoryComponent,
        // TM-1000001976 — geteilter Kundeninformations-Block (self-loading via dunningId)
        BdCustomerInfoComponent,
        // TM-1000001976 — geteilter Bereichs-Ticket-SplitButton + KI-Bereichsanalyse-Block
        BdAreaTicketButtonComponent,
        BdAreaAnalysisComponent,
        // TM-1000001976 — geteilte BD-Prozess-Komponenten
        BdSaldoBlockComponent,
        BdContractDecisionSectionComponent,
        BdOpenFeesSectionComponent,
        BdFinalForderungssichtComponent,
        // Wave 2.1-2.4 — Pending-Action Resolver + Dialoge
        BdPendingActionResolverComponent,
        BdHandOverApprovalDialogComponent,
        BdPlanBreakDecisionDialogComponent,
        BdPauseDialogSharedComponent,
        // DunningProposal Review-Gate (Mahnvorschläge)
        BdDunningProposalApprovalDialogComponent,
        BdDunningProposalWorkbenchComponent,
        // Freigabe-Werkbank der vorgemerkten Stufen-Aktionen (navItem=releases).
        // Ersetzt die entfernte Liste bd-staged-action-review (D5).
        BdDunningActionReleaseWorkbenchComponent,
        // Mahnungs Review Workbench (navItem=browse) + konsolidierte Simulation
        // (navItem=simulate) — aus der Dashboard-Page ausgelagert.
        BdDunningReviewWorkbenchComponent,
        // Incoming money on a running dunning (projects/bm_money_received).
        BdDunningPaymentReviewWorkbenchComponent,
        BdDunningPaymentReviewDetailComponent,
        BdDunningSimulationTabComponent,
        // Mahnungen in der Stopp-Wartezeit (navItem=stopWaiting).
        BdDunningStopWaitingTabComponent,
        // Mahnsperren-Werkbank (navItem=dunningBlocks).
        BdDunningBlockWorkbenchComponent,
        // Arbeitsliste der Übergabe-Freigaben im Freigaben-Tab (W9b).
        BdHandoverApprovalListComponent,
        BdDunningJobsTabComponent,
        BdJobScheduleDialogComponent,
        // Object components
        DunningObjectComponent,
        DunningHandOverObjectComponent,
        DunningPaymentPlanObjectComponent,
        DunningPaymentDistributionObjectComponent,
        DunningTypeObjectComponent,
        DunningProposalObjectComponent,
        // DunningType-OBC — Basis-, Voll- und Seitenansicht des Drei-Schichten-Musters
        BdDunningTypeBaseComponent,
        BdDunningTypeFullComponent,
        BdDunningTypeSideComponent,
        // DunningType-OBC — geteilte Kindtabelle aller zehn Kind-Navigationspunkte
        BdDunningTypeChildTableComponent,
        // bd-dunningtype-overview — rein lesende Konfigurationsübersicht (Navigationspunkt „Übersicht“)
        BdDunningTypeOverviewComponent,
        // Wave 3 — dynamic exit-UI components
        BdContractDecisionTableComponent,
        BdLvDecisionTableComponent,
        BdHandoverApprovalComponent,
        BdPauseDialogComponent,
        BdPlanBreakDecisionComponent,
        BdHandoverConfigurationComponent,
        // Wave 4 — additional dynamic exit-UI components
        BdWriteOffDialogComponent,
        BdRateAgreementDialogComponent,
        BdEscalationDialogComponent,
        BdGenericFormDialogComponent,
    ],
    exports: [
        BdConfigPage,
        BdDunningDashboardPage,
        // Shared components
        DunningBalanceDisplayComponent,
        DunningManualTransactionsSectionComponent,
        BdOpenActionsTabComponent,
        BdOpenActionDrawerComponent,
        BdMahnwesenKpiComponent,
        // Shared pipes
        BdEnumLabelPipe,
        BdReceivableAmountPipe,
        // Transparenz-Audit — Steuerungs-Cockpit (GAP-T01/T07/T11/T12)
        BdKpiTrendComponent,
        BdPortfolioAuditTabComponent,
        BdRunHistoryTabComponent,
        // Welle C — Entscheidungs-Kontext (C01/C02/C11/C13/C14)
        BdDecisionContextComponent,
        BdSaldoBreakdownComponent,
        BdHandOverCompletionSummaryComponent,
        BdContractSimulationComponent,
        BdDunningHistoryComponent,
        // TM-1000001976 — geteilter Kundeninformations-Block (self-loading via dunningId)
        BdCustomerInfoComponent,
        // TM-1000001976 — geteilter Bereichs-Ticket-SplitButton + KI-Bereichsanalyse-Block
        BdAreaTicketButtonComponent,
        BdAreaAnalysisComponent,
        // TM-1000001976 — geteilte BD-Prozess-Komponenten
        BdSaldoBlockComponent,
        BdContractDecisionSectionComponent,
        BdOpenFeesSectionComponent,
        BdFinalForderungssichtComponent,
        // Wave 2.1-2.4 — Pending-Action Resolver + Dialoge
        BdPendingActionResolverComponent,
        BdHandOverApprovalDialogComponent,
        BdPlanBreakDecisionDialogComponent,
        BdPauseDialogSharedComponent,
        // DunningProposal Review-Gate (Mahnvorschläge)
        BdDunningProposalApprovalDialogComponent,
        BdDunningProposalWorkbenchComponent,
        // Freigabe-Werkbank der vorgemerkten Stufen-Aktionen (navItem=releases).
        // Ersetzt die entfernte Liste bd-staged-action-review (D5).
        BdDunningActionReleaseWorkbenchComponent,
        // Mahnungs Review Workbench (navItem=browse) + konsolidierte Simulation
        // (navItem=simulate) — aus der Dashboard-Page ausgelagert.
        BdDunningReviewWorkbenchComponent,
        // Incoming money on a running dunning (projects/bm_money_received).
        BdDunningPaymentReviewWorkbenchComponent,
        BdDunningPaymentReviewDetailComponent,
        BdDunningSimulationTabComponent,
        // Mahnungen in der Stopp-Wartezeit (navItem=stopWaiting).
        BdDunningStopWaitingTabComponent,
        // Mahnsperren-Werkbank (navItem=dunningBlocks).
        BdDunningBlockWorkbenchComponent,
        // Arbeitsliste der Übergabe-Freigaben im Freigaben-Tab (W9b).
        BdHandoverApprovalListComponent,
        BdDunningJobsTabComponent,
        BdJobScheduleDialogComponent,
        // Object components
        DunningObjectComponent,
        DunningHandOverObjectComponent,
        DunningPaymentPlanObjectComponent,
        DunningPaymentDistributionObjectComponent,
        DunningTypeObjectComponent,
        DunningProposalObjectComponent,
        // DunningType-OBC — Basis-, Voll- und Seitenansicht des Drei-Schichten-Musters
        BdDunningTypeBaseComponent,
        BdDunningTypeFullComponent,
        BdDunningTypeSideComponent,
        // DunningType-OBC — geteilte Kindtabelle aller zehn Kind-Navigationspunkte
        BdDunningTypeChildTableComponent,
        // bd-dunningtype-overview — rein lesende Konfigurationsübersicht (Navigationspunkt „Übersicht“)
        BdDunningTypeOverviewComponent,
        // Wave 3 — dynamic exit-UI components
        BdContractDecisionTableComponent,
        BdLvDecisionTableComponent,
        BdHandoverApprovalComponent,
        BdPauseDialogComponent,
        BdPlanBreakDecisionComponent,
        BdHandoverConfigurationComponent,
        // Wave 4 — additional dynamic exit-UI components
        BdWriteOffDialogComponent,
        BdRateAgreementDialogComponent,
        BdEscalationDialogComponent,
        BdGenericFormDialogComponent,
    ],
    imports: [
        CoreModule,
        // JbModule exports the generic <jb-job-run-list> rendered in the "Läufe" tab. jb does
        // not import bd, so this creates no module cycle; dm imports JbModule the same way,
        // and bd already consumes JbJobRunService/JbSpringBatchIndicatorService cross-feature.
        JbModule,
        // NsModule exports NsNotificationTypesForObjectComponent — the ns-owned notification
        // preview embedded in the Mahnvorschlag review workbench. NsModule itself imports only
        // CoreModule, so this creates no module cycle; am and te embed it the same way.
        NsModule,
        // Standalone account-bookings component, reused in the dunning OBC
        // overview (saldo breakdown -> "Buchungen & Offene Positionen"). It is
        // standalone, so importing it does NOT pull in BmModule and therefore
        // does NOT create a BmModule <-> BdModule cycle.
        BmCustomerAccountTransactionComponent
    ],
    providers: [
        BD_ENTITY_PROVIDER,
        BD_TEST_PROVIDERS,
        BD_UI_COMPONENT_REGISTRY_INITIALIZER,
    ]
})
export class BdModule {
}
